import { inject, Injectable } from '@angular/core';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AnalyticsProvider } from '../analytics/analytics';
import { AngularFireStorage } from '../firebase-storage/firebase-storage.provider';
import { UserControllerApi } from '../../../api/services/user-controller-api';
import { Login$Params } from '../../../api/fn/user-controller/login';
import { LoginResponse } from '../../../api/models/login-response';
import { UserType } from '../../../api/models/user-type';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private userApi: UserControllerApi = inject(UserControllerApi);
  private analyticsProvider: AnalyticsProvider = inject(AnalyticsProvider);
  private storage: AngularFireStorage = inject(AngularFireStorage);

  login(givenLogin: string): Observable<UserType | null> {
    const params: Login$Params = {
      body: {
        givenLogin: givenLogin,
      },
    };
    return this.userApi.login(params).pipe(
      tap((userData: LoginResponse) => {
        this.analyticsProvider.sendLogIn(givenLogin, true, userData);
      }),
      switchMap((data: LoginResponse) => {
        return this.userApi.findById({ id_user: data.userId });
      }),
      catchError((error) => {
        this.analyticsProvider.sendLogIn(givenLogin, false, {});
        this.analyticsProvider.recordError('Error login ' + givenLogin);
        let jsonString = JSON.stringify({ login: givenLogin, error });
        this.sendStorage(jsonString, 'err_login_');
        console.error('Error calling API:', error);
        return throwError(() => error);
      })
    );
  }

  sendStorage(jsonString, fileName) {
    let blob = new Blob([jsonString], { type: 'application/json' });
    let logPathDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
    let logPathTime = new Date().toLocaleTimeString().replace(/:/g, '_') + '_' + new Date().getMilliseconds();
    this.storage.upload(environment.name + '/' + logPathDate + '/' + fileName + logPathTime + '.json', blob);
  }
}
